import { message, Popover } from 'antd';
import { useState } from 'react';

import RecordLight from '@/assets/images/RecordLight.svg';
import RecordOn from '@/assets/images/RecordOn.svg';
import * as rtsApi from '@/scene/Meeting/apis/rtsApi';
import { RecordStatus, UserRole } from '@/types/state';

import { useSelector } from '@/store';

import styles from './index.module.less';
import { MenuIconButton, PopoverContent } from '@/components';

export default function () {
  const room = useSelector((state) => state.meetingRoom);
  const [popOpen, setPopOpen] = useState(false);

  const isHost = room.localUser.user_role === UserRole.Host;
  const isRecording = room.record_status === RecordStatus.Recording;

  const handledRecord = () => {
    if (isRecording) {
      rtsApi.stopRecord();
    } else {
      rtsApi.startRecord();
    }

    setPopOpen(false);
  };

  const handleClick = () => {
    if (isHost) {
      setPopOpen(true);
      return;
    }
    if (isRecording) {
      message.error('只有主持人才能停止录制');
    } else {
      rtsApi.startRecordApply();
      message.success('已向主持人发起录制请求');
    }
  };

  return (
    <div className={styles.menuButton}>
      {isHost ? (
        <Popover
          open={popOpen}
          placement="top"
          content={
            <PopoverContent
              okText={isRecording ? '停止录制' : '开始录制'}
              onOk={handledRecord}
              onCancel={() => {
                setPopOpen(false);
              }}
              titleText={`确定${isRecording ? '停止录制' : '开始录制'}吗？`}
            />
          }
        >
          <MenuIconButton
            onClick={handleClick}
            text={room.record_status === RecordStatus.Recording ? '录制中' : '录制'}
            icon={room.record_status === RecordStatus.Recording ? RecordOn : RecordLight}
          />
        </Popover>
      ) : (
        <MenuIconButton
          onClick={handleClick}
          text={room.record_status === RecordStatus.Recording ? '录制中' : '录制'}
          icon={room.record_status === RecordStatus.Recording ? RecordOn : RecordLight}
        />
      )}
    </div>
  );
}
